/**
 * Classe com funções genéricas para as grids dos formularios genericos
 *
 * @author: Kete Martins
 * Date: 08/05/2014
 */


Monet.Builder = Monet.Builder || {};
Monet.Builder.Form = Monet.Builder.Form || {};
Monet.Builder.Form.Grid = Monet.Builder.Form.Grid || {};

Monet.Builder.Form.Grid = (function (){

   function Grid (layoutIndex, entity, customActions) {

        this.gridContainerSelector = "#" + entity + " .gridContainer";
        this.gridActionsSelector = "#" + entity + " .gridActions";
        this.entityToActionGrid = null;
        this.tabSelector = "#" + entity;
        this.defaultActions = ["CUSTOM_FILTERS", "SAVE_LAYOUT", "CUSTOMIZE_COLUMNS", "EXPORT_FORMATS"];
        this.actions = customActions || this.defaultActions;
        this.filterBuilderCallbacks = null;

        this.setGridContainerSelector =  function(gridContainerSelector) {
           this.gridContainerSelector = gridContainerSelector;
        };

        this.setEntityToActionGrid = function (entityToActionGrid){
            this.entityToActionGrid = entityToActionGrid;
        };

        this.setTabSelector = function (tab) {
            if(tab){
                this.tabSelector = tab;
            }
        };

        this.getInstanceOfMenu = function () {
            return null;
        };

       this.addFilterBuilder = function () {

           var filterBuilder = App.Forms[entity].filterBuilder;

           if (!filterBuilder) {

              filterBuilder = new Monet.UI.FilterBuilder();
              filterBuilder.setSelector (this.tabSelector);
              filterBuilder.setEntity (entity);
              filterBuilder.setFieldsOverride({
                TEXT_AREA: 'TEXT'
              });
              var gridActions = document.querySelector(this.gridActionsSelector);
              var div = document.createElement('DIV');
              div.className = 'gridActions ui-widget-header';
              div.appendChild(filterBuilder.el);

              gridActions.parentNode.appendChild(div);

              filterBuilder.render();
              App.Forms[entity].filterBuilder = filterBuilder;

           }

           if (this.filterBuilderCallbacks?.beforeFilter) {
             filterBuilder.setCallbackBeforeFilter(this.filterBuilderCallbacks.beforeFilter);
           }

           filterBuilder.adjustHeaderSize();
       };

       var sortByDefault = function (grid) {
           var columnDefault = App.Forms[entity].columnToOrders;
           var columnSortDefault = [];

           if (columnDefault) {

               var sizeColumnDefault = columnDefault.length;

               for (var i = 0; i < sizeColumnDefault; i++) {

                   var columnToSort = grid.getColumnByFieldName(columnDefault[i].field);
                   var sort = columnDefault[i].order === 'ASC';

                   if (columnToSort) {
                       columnSortDefault.push({columnId: columnToSort.id, sortAsc: sort});
                   }
               }

               if (columnSortDefault.length) {

                   grid.setSortColumns(columnSortDefault);

               }

           }
       };

       var initPagination = function (){
           var paginateOptions = Monet.Grid.Utils.paginationOptions;

           App.Forms[entity].pagination = {
               first: paginateOptions.FIRST,
               max: paginateOptions.MAX_RESULT,
               blocked: false,
               canIncrement: true
           };
       };

       this.getGridOptions = function () {
           const entityToActionGrid = this.entityToActionGrid || entity;
           const showEdit = false;
           const showDelete = false;
           const customOptions = App.Forms[entity]?.customOptions || {};
           const defaultOptions = {
               entity: entity,
               columnCheckBox: {
                   show: showDelete,
                   checkBoxEventClass: [Monet.Grid.ActionsModules.BatchDelete],
                   options: {
                       checkOnClickRow: true
                   }
               },
               columnEdit: {
                   show: showEdit
               },
               actions: this.actions,
               gridActionsSelector: this.gridActionsSelector,
               entityToActionGrid: entityToActionGrid,
               gridContainner: this.gridContainerSelector,
               headerMenu: {
                   headerMenuEventClass: Monet.Grid.ActionsModules.MenuShowTotals
               },
               multiColumnSort: true,
               multiSelect: false,
               frozenColumn : Monet.Grid.getIndexFrozenColumn(layoutIndex)
           };

           let options = Object.assign(defaultOptions, customOptions);

           const relatedList = App.Forms[entity].form.getRelatedLists()[0];
           options = Monet.FormBuilder.checkPermissionToEditAndDeleteBySearchGridAction(relatedList[0], options);

           return options;
       };

       this.getColumnsByGridLayout = () => Monet.Grid.getGridLayout(layoutIndex, entity);

       this.show = function () {

           var columns,
               dataView,
               grid,
               appForms,
               options;

           options = this.getGridOptions();

           columns = this.getColumnsByGridLayout();
           dataView = new Monet.Grid.DataProvider(columns, null, entity);
           grid = new Monet.Grid.GenericGrid(this.gridContainerSelector, dataView, columns, options);

           appForms = App.Forms[entity];
           appForms.table = grid;
           appForms.dataProvider = dataView;

           initPagination();
           sortByDefault(grid);

           this.addFilterBuilder();
       };
   }

   return Grid;

}());
